// src/components/PublicRoute.jsx
import React from "react";
import { useAuth } from "../context/AuthContext";
import { Navigate, Outlet } from "react-router-dom";
import { Loader, Center } from "@mantine/core";
import { getDashboardPath } from "../utils/authHelper";

const PublicRoute = () => {
  // 1. Pastikan useAuth mengembalikan 'role' juga.
  // Jika useAuth belum mengembalikan role, Anda bisa ambil dari localStorage:
  // const role = localStorage.getItem("role");
  const { token, role, loading } = useAuth(); 

  if (loading) {
    return (
      <Center style={{ height: "100vh" }}>
        <Loader />
      </Center>
    );
  }
  
  // 2. UBAH LOGIKA DI SINI
  if (token) {
    // Tentukan tujuan berdasarkan role user yang sedang login
    const destination = getDashboardPath(role);
    return <Navigate to={destination} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;